<template>
  <div>
    <ConfirmDialog
      group="header"
      pt:root:class="!border-0 !bg-transparent"
      pt:mask:class="backdrop-blur-sm"
      class="w-[30rem]"
      style="border-radius: 53px"
    >
      <template #container>
        <AuthSection
          bitrix24LoginMode="'popup'"
          @loginFormSuccess="onLoginSuccess"
          @bitrix24Loginsuccess="onLoginSuccess"
        />
      </template>
    </ConfirmDialog>
  </div>
</template>

<script setup>
import ConfirmDialog from "primevue/confirmdialog";
import { useConfirm } from "primevue/useconfirm";
import AuthSection from "@/components/auth/AuthSection.vue";
import JwtService from "@/core/services/JwtService";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { ROUTES_PUBLIQUES } from "@/router";

const confirm = useConfirm();
const isOpen = ref(false);
const route = useRoute();
const onLoginSuccess = () => {
  confirm.close();
  isOpen.value = false;
};

setInterval(() => {
  // Meme liste que le garde du routeur : sans cela, une page publique affiche
  // bien son contenu mais se fait recouvrir par cette boite de connexion.
  if (ROUTES_PUBLIQUES.includes(route.name)) {
    return;
  }

  const now = Date.now();
  const tokenExpiresAt = JwtService.getExpiresAt() ?? 0;
  if (tokenExpiresAt === null || tokenExpiresAt <= now) {
    showTemplate();
    isOpen.value = true;
  } else {
    confirm.close();
  }
}, 1000);

const showTemplate = () => {
  confirm.require({
    group: "header",
    rejectProps: {
      label: "Cancel",
      icon: "pi pi-times",
      outlined: true,
      size: "small",
    },
    acceptProps: {
      label: "Save",
      icon: "pi pi-check",
      size: "small",
    },
    accept: () => {
      console.log("la");
    },
    reject: () => {
      console.log("la");
    },
  });
};
</script>
